module.exports = __webpack_public_path__ + "img/logo1 (10).4284d1f4.jpg";